/* Native bootstrap for the Capacitor mobile shell.
 *
 * Loaded by App.js at startup. Only does anything when running inside
 * the native iOS or Android shell — no-op on web.
 */
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { App as CapApp } from "@capacitor/app";
import { api } from "@/lib/api";

const isNative = () => Capacitor.isNativePlatform?.() === true;

async function registerPush() {
  try {
    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== "granted") return;
    await PushNotifications.register();
  } catch (err) {
    console.warn("Push register failed:", err);
  }
}

function wireListeners() {
  PushNotifications.addListener("registration", async (token) => {
    try {
      await api.post("/me/device-token", {
        token: token.value,
        platform: Capacitor.getPlatform(),
      });
    } catch (err) {
      console.warn("Device token sync failed:", err);
    }
  });
  PushNotifications.addListener("registrationError", (err) => {
    console.warn("Push registration error:", err);
  });
  PushNotifications.addListener("pushNotificationReceived", (notif) => {
    // Pipe into the existing in-app toaster.
    window.dispatchEvent(new CustomEvent("pb:notification", { detail: notif }));
  });
  PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
    const link = action?.notification?.data?.link;
    if (link) window.location.assign(link);
  });

  CapApp.addListener("appUrlOpen", ({ url }) => {
    // Universal-link deep links: powerbuilt://path or https://app.powerbuilt.sxm/path
    try {
      const u = new URL(url);
      window.location.assign(u.pathname + u.search + u.hash);
    } catch {
      /* ignore */
    }
  });
}

export async function initNativeMobile() {
  if (!isNative()) return;
  wireListeners();
  await registerPush();
}
